import React, { Component } from 'react';

export default class SubmitError extends Component {
  render() {
    return <p className="book-a-viewing__submit-error">{this.props.errorMessage}</p>;
  }
}
